function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    style: {
      "textIndent": 0,
      "textAlign": "start",
      "lineHeight": "normal",
      "textTransform": "none",
      "blockProgression": "tb",
      "InkscapeFontSpecification": "Bitstream Vera Sans"
    },
    d: "M 4 4 L 4 5 L 4 13 L 6 13 L 6 7.4375 L 14.5625 16 L 6 24.5625 L 6 19 L 4 19 L 4 27 L 4 28 L 5 28 L 13 28 L 13 26 L 7.4375 26 L 16 17.4375 L 24.5625 26 L 19 26 L 19 28 L 27 28 L 28 28 L 28 27 L 28 19 L 26 19 L 26 24.5625 L 17.4375 16 L 26 7.4375 L 26 13 L 28 13 L 28 5 L 28 4 L 27 4 L 19 4 L 19 6 L 24.5625 6 L 16 14.5625 L 7.4375 6 L 13 6 L 13 4 L 5 4 L 4 4 z"
  }));
};

export default __webpack_public_path__ + "static/media/resize-four-directions.8eae841e.svg";
export { SvgComponent as ReactComponent };